import React from "react";
import {css, useTheme} from "@emotion/react";

import {color, mb, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {ArticleCommentStatus, IArticleComment} from "../../actions/fetch_article_comment_list";
import {ArticleCommentItemText} from "./ArticleCommentItemText";

interface IProps {
    comments: IArticleComment[];
    className?: string;
}

export const ArticleCommentList: React.FunctionComponent<IProps> = ({comments, className}) => {
    const theme = useTheme();
    const grayTextColor = color(theme.colors.gray[700]);
    return (
        <ul className={className} css={commentListing}>
            {comments.map(
                (comment) =>
                    comment.status === ArticleCommentStatus.ACCEPTED && (
                        <li key={comment.id}>
                            <Text as="p" css={[mb(2), grayTextColor]} variant="info_txt_2">
                                {comment.nick_name && comment.nick_name}
                                {comment.author && !comment.nick_name && (comment.author.name ? comment.author.name : concatWithBrandName("użytkownik"))}
                            </Text>

                            <ArticleCommentItemText text={comment.text} date={comment.create_date} />

                            {comment.children && (
                                <div css={[p(2, 2, 1, 2), onDesktop(p(4, 3, 3, 2))]}>
                                    {comment.children.map(
                                        (subComment, sub_id) =>
                                            subComment.status === ArticleCommentStatus.ACCEPTED && (
                                                <div key={`${subComment.id}_${sub_id}`}>
                                                    <Text as="p" css={[mb(2), grayTextColor]} variant="info_txt_2">
                                                        {subComment.nick_name && subComment.nick_name}

                                                        {subComment.author &&
                                                            !subComment.nick_name &&
                                                            (subComment.author.name ? subComment.author.name : concatWithBrandName("użytkownik"))}
                                                    </Text>
                                                    <ArticleCommentItemText text={subComment.text} date={subComment.create_date} />
                                                </div>
                                            )
                                    )}
                                </div>
                            )}
                        </li>
                    )
            )}
        </ul>
    );
};

const commentListing = css`
    list-style: none;
    padding: 0;
`;
